import { combineReducers } from 'redux';

import entities from './entities/reducers';
import loadingState from './loadingState/reducers';
import { ACTION_TYPES } from './constants';

const selectedDashboardId = (state = '', action) => {
  switch (action.type) {
    // case ACTION_TYPES.CREATE_DASHBOARD_REQUEST:
    //   return true;
    // case ACTION_TYPES.CREATE_DASHBOARD_SUCCESS:
    // case ACTION_TYPES.CREATE_DASHBOARD_FAILURE:
    //   return false;
    default: {
      return state;
    }
  }
};

export default combineReducers({
  entities,
  loadingState,
  selectedDashboardId,
});
